import { IconMinus, IconPlus } from '@tabler/icons-react';
import React from 'react';
import { Table } from '@mantine/core';

const ReviewTableRow = ({ subscription, type }) => {
  const subscriptionTierFields = subscription.subscriptionTieredPricings.map((pricing) => {
    return (
      <Table.Tr key={`${subscription.id}${pricing.id}`}>
        <Table.Td></Table.Td>
        <Table.Td>Price per tier</Table.Td>
        <Table.Td></Table.Td>
        <Table.Td>
          {parseFloat(pricing.price || 0).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 5,
          })}
        </Table.Td>
      </Table.Tr>
    );
  });
  const subscriptionDynamicFields = subscription.subscriptionDynamicPricings.map((pricing) => {
    return (
      <Table.Tr key={`${subscription.id}${pricing.id}`}>
        <Table.Td></Table.Td>
        <Table.Td>Price per unit</Table.Td>
        <Table.Td>{pricing.unit}</Table.Td>
        <Table.Td>
          {parseFloat(pricing.unitPrice || 0).toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 5,
          })}
        </Table.Td>
      </Table.Tr>
    );
  });

  return (
    <>
      <Table.Tr style={{ fontWeight: 'bold' }}>
        <Table.Td>{subscription.name}</Table.Td>
        <Table.Td>Type of pricing</Table.Td>
        <Table.Td>Pricing unit</Table.Td>
        <Table.Td>Price</Table.Td>
      </Table.Tr>
      {subscriptionTierFields}
      {subscriptionDynamicFields}
    </>
  );
};

const ReviewSubscription = ({ domainSubscriptions, newSubscriptions, domainSubscriptionType }) => {
  const domainSubscriptionsRows = domainSubscriptions.map((sub) => <ReviewTableRow key={sub.id} subscription={sub} />);
  const newSubscriptionsRows = newSubscriptions.map((sub) => (
    <ReviewTableRow key={sub.id} subscription={sub} type="new" />
  ));

  const calculateTotalPrice = () => {
    if (domainSubscriptionType === 'flagship') {
      const oldPrice = domainSubscriptions.reduce((sum, sub) => sum + sub.subscriptionTieredPricings[0].price, 0);
      const newPrice = newSubscriptions.reduce((sum, sub) => sum + sub.subscriptionTieredPricings[0].price, 0);

      return { old: oldPrice, new: newPrice };
    } else {
      const oldPrice = domainSubscriptions.reduce((sum, sub) => {
        if (sub.subscriptionTieredPricings[0]) {
          return sum + sub.subscriptionTieredPricings[0].price;
        }
        const seatsPricings = sub.subscriptionDynamicPricings.findIndex((pricing) => pricing.unit === 'seats');
        if (seatsPricings !== -1) {
          return sum + sub.subscriptionDynamicPricings[seatsPricings].unitPrice;
        }
        return sum;
      }, 0);

      const newPrice = newSubscriptions.reduce((sum, sub) => {
        if (sub.subscriptionTieredPricings[0]) {
          return sum + sub.subscriptionTieredPricings[0].price;
        }
        return sum;
      }, 0);

      return { old: oldPrice, new: parseFloat(newPrice) + parseFloat(oldPrice) };
    }
  };

  const totalPrice = calculateTotalPrice();

  return (
    <Table striped withTableBorder highlightOnHover>
      <Table.Tbody>
        <Table.Tr style={domainSubscriptionType === 'flagship' ? { color: 'var(--mantine-color-red-6)' } : null}>
          <Table.Td style={{ fontWeight: 'bold' }} colSpan={4}>
            {domainSubscriptionType === 'flagship' ? <IconMinus size={14} /> : null} Old subscriptions
          </Table.Td>
        </Table.Tr>

        {domainSubscriptionsRows}
        <Table.Tr style={{ color: 'var(--mantine-color-green-6)' }}>
          <Table.Td style={{ fontWeight: 'bold' }} colSpan={4}>
            <IconPlus size={14} /> New subscriptions
          </Table.Td>
        </Table.Tr>
        {newSubscriptionsRows}
        <Table.Tr>
          <Table.Td style={{ fontWeight: 'bold', textAlign: 'right' }} colSpan={3}>
            Old total price:
          </Table.Td>
          <Table.Td style={{ color: '#888', textDecoration: 'line-through', paddingRight: 5, fontWeight: 400 }}>
            {parseFloat(totalPrice.old || 0).toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
              maximumFractionDigits: 5,
            })}
          </Table.Td>
        </Table.Tr>
        <Table.Tr>
          <Table.Td style={{ fontWeight: 'bold', textAlign: 'right' }} colSpan={3}>
            New total price:
          </Table.Td>
          <Table.Td style={{ fontWeight: 600 }}>
            {parseFloat(totalPrice.new || 0).toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
              maximumFractionDigits: 5,
            })}
          </Table.Td>
        </Table.Tr>
      </Table.Tbody>
    </Table>
  );
};

export default ReviewSubscription;
